import type {
  LanguageResources,
  TranslationSchema,
} from "../types/translation.types";
import i18n from "./config";

export function registerFeatureTranslations<T extends TranslationSchema>(
  namespace: string,
  resources: LanguageResources<T>,
) {
  Object.entries(resources).forEach(([lng, value]) => {
    i18n.addResourceBundle(lng, namespace, value);
  });
}
export function changeLanguage(lng: string) {
  i18n.changeLanguage(lng);
}

